<template>
    <div>
        <div ref="modal" 
            class="modal fade" 
            data-bs-backdrop="static" 
            tabindex="-1" 
            aria-labelledby="erkModalLabel" 
            aria-modal="true" 
            role="dialog" 
            style="padding-right: 17px;">
            <div class="modal-dialog modal-dialog-scrollable modal-lg">
                <div class="modal-content">
                    <div class="modal-header py-2 pe-2">
                        <strong class="modal-title" id="erkModalLabel">Dati esercizio</strong>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div v-if="isLoading" class="message">
                            Caricamento...
                        </div>
                        <div v-else-if="content && content.content">
                            <h2 class="text-center mb-2">{{ content.content.name }}</h2>
                            <div class="text-center mb-3">
                                <em>{{ content.content.authors }}</em>
                            </div>
                            
                            <img :src="content.content.thumbnail_large" class="img-fluid"/>

                            <table class="mt-3">
                                <tr v-if="content.metadata['32']">
                                    <td>
                                        <strong>Consegna</strong>
                                    </td>
                                    <td>
                                        {{ content.metadata["32"] }}
                                    </td>
                                </tr>
                                <tr v-if="content.content.tempo_stimato">
                                    <td>
                                        <strong>Tempo svolgimento stimato</strong>
                                    </td>
                                    <td>
                                        {{ content.content.tempo_stimato }} minuti
                                    </td>
                                </tr>
                                <tr v-if="content.content.sottoprocesso_2024">
                                    <td>
                                        <strong>Processo</strong>
                                    </td>
                                    <td>
                                        {{ content.content.sottoprocesso_2024 }}
                                    </td>
                                </tr>
                                <tr v-if="content.metadata.content_classe_da">
                                    <td>
                                        <strong>Classe</strong>
                                    </td>
                                    <td>
                                        {{ content.metadata.content_classe_da }} 
                                        <template v-if="content.metadata.content_classe_a">
                                            - {{ content.metadata.content_classe_a }}
                                        </template>
                                    </td>
                                </tr>
                                <tr v-if="content.metadata.content_opera">
                                    <td>
                                        <strong>Opera originale</strong>
                                    </td>
                                    <td>
                                        {{ content.metadata.content_opera }}
                                    </td>
                                </tr>
                                <tr v-if="content.content.code_must">
                                    <td>
                                        <strong>Codice</strong>
                                    </td>
                                    <td>
                                        {{ content.content.code_must }}
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-secondary close-btn" data-bs-dismiss="modal" aria-label="Close">                             
                            Chiudi
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios"

export default{
    props: {
    },
    data(){
        return {
            isLoading: false,
            content: {},
            modal: null
        }
    },
    created(){

    },
    methods: {
        open(contentId){
            if (this.modal == null){
                this.modal = new window.bootstrap.Modal( this.$refs.modal )
            }
            
            this.modal.show()
            this.loadData(contentId)
        },
        loadData(contentId){
            this.content = null
            this.isLoading = true

            axios.get('/structure/content/ContentFindAction-info?contentId=' + contentId)
                .then((response) => {
                    console.log(response)
                    this.isLoading = false
                    if (response.data.hasErrors){
                        alert(response.data.errors)
                        return
                    }

                    this.content = response.data.data
                })
                .catch((error) => {
                    this.isLoading = false
                    alert(error)
                })
        }
    }
}

</script>
<style scoped>
td{
    padding: 10px;
}
</style>